import { ENDPOINTS, FETCH_SIDEBAR_PAGEDATA } from 'src/constants';
import { axios } from 'src/lib';
import Storage from 'src/utils/storage/storage';

export function fetchSideNavBarData(sourceId: number) {
  return axios
    .get(`${FETCH_SIDEBAR_PAGEDATA}${sourceId}/`)
    .then((response) => response.data)
    .catch((error) => {
      console.error('Error fetching side nav bar data:', error);
      throw error;
    });
}

export function logout() {
  return axios.post(ENDPOINTS.logoutUrl, {
    refresh_token: Storage.getRefreshToken()
  });
}
